export function FirstLikeReceivedIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M24 38s-14-8-14-18c0-5 4-10 9-10a9 9 0 015 2 9 9 0 015-2c5 0 9 5 9 10 0 10-14 18-14 18z"
        fill="currentColor"
        opacity="0.2"
      />
      <path d="M24 38s-14-8-14-18c0-5 4-10 9-10a9 9 0 015 2 9 9 0 015-2c5 0 9 5 9 10 0 10-14 18-14 18z" />
      <path d="M18 22l4 4 8-8" />
    </svg>
  );
}
